export const HtmlComponent = ({template}) => {
	const innerHtml = {
		__html: template
	}

	return (
		<div dangerouslySetInnerHTML={innerHtml} />
	)
}

